import styled, { css } from "styled-components";
import ReactDayPicker from "react-day-picker";

import { media } from "src/library/utils";

import "react-day-picker/lib/style.css";

export const DayPicker = styled(ReactDayPicker)`
  * {
    outline: none;
  }
  ${({ theme }) => css`
    /* DARK THEME */
    &.dark {
      &.DayPicker:not(.DayPicker--interactionDisabled)
        .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
        &.DayPicker-Day--warning {
          background-color: ${theme.colors.error}20;
        }

        background-color: #6499ff20;
      }

      .DayPicker-Day {
        color: ${theme.colors.lightGrey};

        &.DayPicker-Day--disabled {
          color: ${theme.colors.lightGrey}50;
        }

        &.DayPicker-Day--selected {
          &.DayPicker-Day--withOrders {
            color: #6499ff;
            font-weight: bold;
            position: relative;
            background-color: #6499ff20;

            &::before {
              background: #6499ff;
            }
            &:hover {
              background-color: #6499ff20;
            }
          }

          &.DayPicker-Day--warning {
            color: ${theme.colors.error};
            font-weight: bold;
            background-color: ${theme.colors.error}20;
            &:hover {
              background-color: ${theme.colors.error}20;
            }
          }
        }

        &.DayPicker-Day--withOrders {
          color: #6499ff;
          font-weight: bold;
          position: relative;
          &:hover {
            background-color: #6499ff20;
          }
          &::before {
            background: #6499ff;
          }
        }

        &.DayPicker-Day--warning {
          color: ${theme.colors.error};
          font-weight: bold;

          &::before {
            background: ${theme.colors.error};
          }
          &:hover {
            background-color: ${theme.colors.error}20;
          }
        }
      }
    }
    /* LIGHT (DEFAULT) THEME */
    .DayPicker-Day {
      line-height: 25px;
      height: 25px;
      width: 25px;
      font-size: 15px;
      border-radius: 4px;
      outline: none;
      color: ${theme.colors.darkGrey};

      &.DayPicker-Day--warning {
        color: ${theme.colors.warn};
      }

      &.DayPicker-Day--disabled {
        color: ${theme.colors.lightGrey};
      }

      &:not(.DayPicker-Day--outside) {
        &:not(.DayPicker-Day--disabled):hover {
          background-color: ${theme.colors.primaryDark};
        }

        &.DayPicker-Day--selected {
          background-color: ${theme.colors.primaryDark};
          border-radius: 4px;

          &.DayPicker-Day--withOrders {
            position: relative;

            &::before {
              background: white;
            }
          }

          &.DayPicker-Day--disabled {
            background-color: ${theme.colors.lightGrey}50;
          }
        }
      }

      &.DayPicker-Day--withOrders {
        position: relative;

        &::before {
          display: block;
          transform: translateX(-50%);
          border-radius: 4px;
          position: absolute;
          background: ${theme.colors.primaryDark};
          height: 4px;
          content: "";
          width: 4px;
          left: 50%;
          bottom: 10%;
        }
      }
    }

    .DayPicker-Week {
      padding-bottom: 1px;
    }

    .DayPicker-Month,
    .DayPicker-Months {
      ${media({ lt: theme.breakpoints.sm })} {
        width: 100%;
      }
    }
  `}
`;
